export default "__VITE_ASSET__BLLGD2HG__"